module.exports = __webpack_public_path__ + "static/media/linkedin.72249a9b.png";